import React from 'react';
import {Provider} from 'mobx-react';
import ReactDOM from 'react-dom';
import BasicLayout from './layouts/BasicLayout';
import store from './stores';
import * as serviceWorker from './serviceWorker';
import {IntlProvider} from 'react-intl';
import zh_CN from './locales/zh_CN/menu';
import { notification,ConfigProvider } from 'antd';
import './styles/v2-compatible-reset';
import zhCN from 'antd/es/locale/zh_CN';
import IsJson from '@/utils/IsJson';

if (IsJson(window.localStorage.getItem('userInfo') || null) === false) {
  window.localStorage.removeItem('userInfo')
}

let messages: any = {};
messages['zh'] = zh_CN;

notification.config({
  placement: 'bottomRight',
  bottom: 50,
  duration: 3,
});



ReactDOM.render(
    <Provider {...store}>
        <IntlProvider locale='zh' messages={zh_CN}>
          <ConfigProvider locale={zhCN}>
            <BasicLayout />
          </ConfigProvider>
        </IntlProvider>
    </Provider>
    , document.getElementById('root'));

serviceWorker.unregister();
